import { combineReducers } from 'redux'
import * as ActionTypes from '../../actions/actionTypes'

/** @reducer **/
const entities = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.OMNITEC_LOCKS_FETCH_SUCCESS:
            return { ...state, omnitecLocks: [...action.data] }
        default:
            return state
    }
}

/** @reducer **/
const result = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.OMNITEC_LOCKS_FETCH_SUCCESS:
            return [...action.data]
        default:
            return state
    }
}

/** @reducer **/
const isFetching = (state = false, action) => {
    switch (action.type) {
        case ActionTypes.OMNITEC_LOCKS_FETCH_REQUEST:
            return true
        case ActionTypes.OMNITEC_LOCKS_FETCH_SUCCESS:
            return false
        case ActionTypes.OMNITEC_LOCKS_FETCH_FAILURE:
            return false
        default:
            return state
    }
}

/** @reducer **/
const error = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.OMNITEC_LOCKS_FETCH_FAILURE:
            return action.data
        default:
            return state
    }
}

export default combineReducers({ entities, isFetching, result, error })



// WEBPACK FOOTER //
// ./src/reducers/omnitecReducers/omnitecLocks.js